// Google Ads landing pages. Each entry is a distraction-free page at /lp/{slug}
// and tags its enquiries with `source` so campaigns can be measured in the admin.
export const LANDING_PAGES = {
  "property-in-pune": {
    city: "Pune",
    eyebrow: "Zero brokerage · Verified owners",
    headline: "Find your next home in Pune — without paying brokerage",
    sub: "Flats, houses and PGs across Baner, Wakad, Hinjewadi, Kharadi and Viman Nagar. Talk directly to the owner, no middlemen.",
    heroQuery: "pune city apartment building",
    hero: "https://images.unsplash.com/photo-1714983007778-b370188238b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    browsePath: "/pune/flats-for-rent",
  },
  "property-in-delhi-ncr": {
    city: "Delhi NCR",
    eyebrow: "Zero brokerage · Verified owners",
    headline: "Rent or buy in Delhi NCR, straight from the owner",
    sub: "Flats, builder floors and PGs across Noida, Gurgaon, Dwarka and Greater Noida — real photos and the owner's number on every listing.",
    heroQuery: "delhi apartment skyline",
    hero: "https://images.unsplash.com/photo-1615683212302-30c0a8c5a02f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    browsePath: "/delhi-ncr/flats-for-rent",
  },
  "property-in-mumbai": {
    city: "Mumbai",
    eyebrow: "Zero brokerage · Verified owners",
    headline: "Mumbai homes you can enquire about today",
    sub: "1, 2 and 3 BHK flats plus PGs across Andheri, Bandra, Powai and Thane — direct owner contact, no brokerage.",
    heroQuery: "mumbai apartment skyline",
    hero: "https://images.unsplash.com/photo-1710582308582-55cc0c461c4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    browsePath: "/mumbai/flats-for-rent",
  },
  "list-your-property": {
    city: null,
    eyebrow: "Free listing · Live in minutes",
    headline: "List your property free and get genuine enquiries",
    sub: "Post your flat, house, PG or shop in a few minutes. Buyers call you directly, you keep full control — and every enquiry lands in your dashboard.",
    heroQuery: "indian family new home keys",
    hero: "https://images.unsplash.com/photo-1758523671826-d7f8217ffac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    browsePath: "/post-property",
    ownerFirst: true,
  },
  "pg-and-coliving": {
    city: null,
    eyebrow: "For students & working professionals",
    headline: "PGs and co-living with the food menu shown upfront",
    sub: "Compare beds, rent, sharing type and the actual weekly food menu before you visit. No brokerage, owner contact on every listing.",
    heroQuery: "hostel shared bedroom interior",
    hero: "https://images.unsplash.com/photo-1781415980730-bfcf192e38bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    browsePath: "/properties?category=pg",
  },
};

export const TRUST_POINTS = [
  { title: "Zero brokerage", text: "Deal directly with owners — we never charge a commission." },
  { title: "Verified listings", text: "Real photographs and owner-confirmed contact details." },
  { title: "Fast responses", text: "Your enquiry reaches the owner instantly by email." },
  { title: "Free to list", text: "Owners and dealers post unlimited properties at no cost." },
];
